import type { SVGProps } from "react";
export interface AdobeAiIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AdobeAiIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AdobeAiIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 12A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M8.225 8.14c.558-1.687 2.99-1.687 3.55 0l.05.175 1.769 7.424.022.113a1.125 1.125 0 0 1-2.178.52l-.033-.112-.39-1.635H8.985l-.39 1.635a1.125 1.125 0 0 1-2.188-.521l1.77-7.424zm6.65 7.86v-5a1.125 1.125 0 0 1 2.25 0v5a1.125 1.125 0 0 1-2.25 0m-5.354-3.624h.958L10 10.367zm6.488-5.501.116.006a1.124 1.124 0 0 1 0 2.238l-.116.006H16a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
